import { MuiThemeProvider, Paper, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enCustomizationForm, IThemeCustomizerOptions } from 'interfaces/theme';
import { PureComponent } from 'react';
import * as React from 'react';
import * as rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import ActionButton from './Forms/ActionButton';
import Background from './Forms/Background';
import Form from './Forms/Form';
import LanguageSelectBar from './Forms/LanguageSelectBar';
import PrincipalMedia from './Forms/PrincipalMedia';
import ShortageTimer from './Forms/ShortageTimer';
import SideBanner from './Forms/SideBanner';
import ToastMessages from './Forms/ToastMessages';
import TopBanner from './Forms/TopBanner';
import WidgetPrincipalMedia from './Forms/WidgetPrincipalMidia';

interface IProps {
  classes?: any;
}

interface IState {
  openForm: boolean;
  option: IThemeCustomizerOptions;
}

@WithStyles(theme => ({
  root: {
    position: 'absolute',
    left: '17.5vw',
    width: 320,
    marginTop: 8,
    zIndex: 2,
    padding: theme.spacing.unit * 2,
    maxHeight: '85vh',
    overflowY: 'auto'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  closeForm: {
    cursor: 'pointer',
    '& svg': {
      width: 11,
      fill: '#596375'
    }
  },
  title: {
    marginTop: '0.35rem'
  },
  subtitle: {
    fontSize: 15,
    letterSpacing: 0.45
  }
}))
export default class CustomizerOptionForm extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { openForm: true, option: null };
  }

  componentDidMount() {
    themeCustomizerService
      .shouldOpenForm()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe(openForm => {
        this.setState(oldState => {
          return { ...oldState, openForm };
        });
      });

    themeCustomizerService
      .getSelectedOption()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe(option => {
        this.setState(oldState => {
          return { ...oldState, option };
        });
      });
  }

  componentWillUnmount() {
    themeCustomizerService.setSelectedOption(null);
  }

  handleClose = () => {
    themeCustomizerService.closeForm();
  };

  getFormComponent = (id: string) => {
    if (id === enCustomizationForm.ActionButton) {
      return <ActionButton />;
    }

    if (id === enCustomizationForm.ToastMessages) {
      return <ToastMessages />;
    }

    if (id === enCustomizationForm.ShortageTimer) {
      return <ShortageTimer />;
    }

    if (id === enCustomizationForm.LanguageSelectBar) {
      return <LanguageSelectBar />;
    }

    if (id === enCustomizationForm.Form) {
      return <Form />;
    }

    if (id === enCustomizationForm.Background) {
      return <Background />;
    }

    if (id === enCustomizationForm.PrincipalMedia) {
      return <PrincipalMedia />;
    }

    if (id === enCustomizationForm.TopBanner) {
      return <TopBanner />;
    }

    if (id === enCustomizationForm.SideBanner) {
      return <SideBanner />;
    }

    if (id === enCustomizationForm.WidgetPrincipalMedia) {
      return <WidgetPrincipalMedia />;
    }

    return null;
  };

  render() {
    const { classes } = this.props;
    const { openForm, option } = this.state;

    if (!openForm || !option) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <Paper className={classes.root} elevation={3}>
          <div className={classes.header}>
            <Typography variant="title" gutterBottom className={classes.title}>
              {option.title}
            </Typography>
            <div className={classes.closeForm} onClick={this.handleClose}>
              <SvgIcon name="close" />
            </div>
          </div>
          <Typography variant="body2" gutterBottom className={classes.subtitle}>
            {option.description}
          </Typography>

          {this.getFormComponent(option.id)}
        </Paper>
      </MuiThemeProvider>
    );
  }
}
